export default __webpack_public_path__ + "static/media/ASSETS-08.79c91250.png";